export const TERMS_OF_USE = 'policy/terms-of-use.html';
export const REFUND_POLICY = 'policy/refund-policy.html';
export const PRIVACY_POLICY = 'policy/privacy-policy.html';
